import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Inject,
  OnInit,
  QueryList, ViewChild,
  ViewChildren
} from '@angular/core';

import { AlertController, ModalController, PopoverController } from '@ionic/angular';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalPopoverPage } from "../shared/modal-popover/modal-popover.page";
import * as AOS from 'aos';
import { AppServiceService } from "../../../api/app-service.service";
import consts from "../shared/constatnts.json";
import { TranslateService } from '@ngx-translate/core';
import { DOCUMENT, Location } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { StorageService } from 'src/app/core/storage.service';
import { DeliveryTimesPage } from '../../modals/delivery-times/delivery-times.page';

@Component({
  selector: 'app-web-menu',
  templateUrl: './web-menu.page.html',
  styleUrls: ['./web-menu.page.scss'],

})
export class WebMenuPage implements OnInit {
  anicartstyle = '';
  animationcarticon = 'animation-cart-icon';
  @ViewChildren('.menu-list-container') componentDiv: QueryList<any>;
  @ViewChild('animationicon') animationicon: HTMLElement;
  @ViewChild('maincarticon', { read: ElementRef }) maincarticon: ElementRef;

  // order now button animated arrow colors
  @HostBinding('style.--brushstoke-color')
  public brushColor: string = '';

  array = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', ''];
  POPOVER_TYPES = consts.POPOVER_TYPES;
  // public couponAdded = false;
  coupon: any = '';
  public couponError: string = '';
  public couponValidating: boolean = false;
  public couponValidatingNew: boolean = false;
  public scrolltoActive = 1;

  public baseUrl = environment.BASE_URL;

  public lang: any = null;

  public onlyWelcomePackageCanBeOrdered: boolean = false;

  public dishesLoaded: boolean = false;
  public doNotTriggerParamChanges:boolean = false;
  public menuLoadingCompleteCallBack:any = null;

  constructor(public modalController: ModalController, public appService: AppServiceService, public translate: TranslateService, 
    @Inject(DOCUMENT) private document: Document, public router: Router, public route: ActivatedRoute, 
    public alertController: AlertController,public popoverCtrl: PopoverController, private storage: StorageService, private cdRef: ChangeDetectorRef, private location:Location) {

    appService.isWebVersion = true;
    appService.themeConfigFor = 'web'

    // get theme object previously saved in local storage
    let inter = setInterval(() => {
      if (this.appService.isThemeObjectLoaded) {
        if (this.appService.appObject.theme && this.appService.appObject.theme.web && this.appService.appObject.theme.web.menu && this.appService.appObject.theme.web.menu.restaurantTitleBrushColor) {
          this.brushColor = this.appService.appObject.theme.web.menu.restaurantTitleBrushColor;
        }
        clearInterval(inter);
      }
    }, 100);
  }


  async ngOnInit() {
    setTimeout(() => {
      AOS.init();
    }, 1000);
    //clear cart items that are not added by today
    // this.appService.clearCartItemsThatAreNotAddedByToday();
    setTimeout(() => {
      if(this.appService.appObject.selectedRestaurantDetails && this.appService.appObject.selectedRestaurantDetails.topping_popup_type == 'wizard'){
        this.appService.watchDishesGettingLoaded().subscribe(async (response) =>{
          console.log('dishesLoaded : ', this.dishesLoaded);
          this.dishesLoaded = true;
          this.cdRef.detectChanges();
        });
        }
    }, 2000);

    this.route.queryParams.subscribe(async (param) => {
      // console.log('param : ', param);
      if (param.markedAsFavourite && param.markedAsFavourite === 'true' && this.appService.appObject.favouriteRestaurant) {
        setTimeout(async () => {
          const alert = await this.alertController.create({
            message: 'You\'ve selected ' + this.appService.appObject.favouriteRestaurant.name + ' as your favorite restaurant.',
            buttons: ['OK']
          });

          await alert.present();
        }, 2000);
      }

      // when user came from order summary page order same again feature
      if (param.re_order === 'true' && this.appService.appObject.reOrderObject) {
        // this.doNotTriggerParamChanges = true;
        // Update the URL in the address bar without reloading, to remove parameters
        const urlWithoutQueryParams = this.router.createUrlTree([], { relativeTo: this.route, queryParams: {} }).toString();
        this.location.go(urlWithoutQueryParams);
        this.appService.reorderInProgress = true;

        if(!this.menuLoadingCompleteCallBack){
          this.menuLoadingCompleteCallBack = this.appService.watchDishesGettingLoaded().subscribe(async (response) =>{
            // console.log('All Dishes Are Loaded : ' , this.appService.appObject.reOrderObject);
            let orderObject = this.appService.appObject.reOrderObject;
            // this.appService.appObject.reOrderObject = null;

            this.appService.addItemsToCartFromSelectedOrder();

            this.appService.reorderInProgress = false;
          });
        }
      }
    })

    this.getLang();
  }

  ngAfterViewInit() {
    // set an intevel to check wether settings are loaded, if loaded then check selectedDeliverymethod available or not
    // if not then redirect into home page
    let int = setInterval(() => {
      if (this.appService.isSettingsLoaded) {
        clearInterval(int);
        if (!this.appService.appObject.selectedDeliveryMethod) {
          this.router.navigate(['home']);
        }
        // set brush color from theme object again to get any new changes
        if (this.appService.appObject.theme && this.appService.appObject.theme.web && this.appService.appObject.theme.web.menu && this.appService.appObject.theme.web.menu.restaurantTitleBrushColor) {
          this.brushColor = this.appService.appObject.theme.web.menu.restaurantTitleBrushColor;
        }

        // disable coupon input if there is coupon available already
        if (this.appService.appObject.couponWeb) {
          this.appService.appObject.couponWebAdded = true;
          this.appService.updateAppObject();
        }

      }
    }, 1000);
  }

  ionViewWillEnter() {
    // get parameters from route then get selected restaurant details
    let isRestaurantDataFetched = false;
    // assign subscription for 
    let paramSubscription = this.route.params.subscribe(async (param) => {
      if (param.slug) {
        this.appService.doNotFetchMain = true;
        await this.appService.getRestaurantBySlug(param.slug);
        this.appService.startHeartBeat(param.slug);
        // do calculations if there are any dishes in the cart already when load the page
        if (this.appService.appObject.orderObject && this.appService.appObject.orderObject.cart && this.appService.appObject.orderObject.cart.length)
          this.appService.calculateCartAmounts();

        isRestaurantDataFetched = true;
      }
    });

    // destroy param subscription coz, if user chooes to reorder from here it will creates two subscriptions
    paramSubscription.unsubscribe();

    this.route.queryParams.subscribe((param) =>{
      if(param.pointRecharge === 'true'){
        let wait = setInterval(() =>{
          if(isRestaurantDataFetched){
            this.openCheckout();
            clearInterval(wait);
          }
        },1000);
      }
    });

    if (this.appService.welcomePackageOnTheWay) {
      // console.log('welcome package on the way');
      // add welcome order package to the cart
      this.appService.appObject.orderObject.claimWelcomePackage = true;
      this.appService.updateAppObject();

      if(this.appService.welcomePackageOnTheWayFromDirectLink){
        this.openCheckout();
      }
    }

    if (this.appService.appObject.orderObject.claimWelcomePackage && this.appService.appObject.settings && this.appService.appObject.settings.main_restaurant && this.appService.appObject.settings.main_restaurant.welcome_package_configurations) {
      let welcomePackageConfig = this.appService.appObject.settings.main_restaurant.welcome_package_configurations;
      if (welcomePackageConfig.able_only_welcome_order_status) this.onlyWelcomePackageCanBeOrdered = true;
    }

    this.route.queryParams.subscribe(async (qParams) => {
      if (qParams.checkoutStatus === 'true' && qParams.paymentId) {
        await this.appService.clearCart();
        this.appService.clearCartCalled = true;

        let component = {
          'type': (qParams.subscription && qParams.subscription === 'true' ? this.POPOVER_TYPES.SUBSCRIPTION_SUMMARY.TYPE : this.POPOVER_TYPES.ORDER_SUMMARY.TYPE),
          'title': this.appService.appObject.selectedDeliveryMethod ? ('key.' + this.appService.appObject.selectedDeliveryMethod) : '',
          'uniqueId': qParams.paymentId
        }

        const modal = await this.modalController.create({
          component: ModalPopoverPage,
          cssClass: 'order-popup',
          componentProps: component
        });

        modal.present();
      } else if (qParams.checkoutStatus === 'false') {
        setTimeout(() => {
          this.appService.showToast(this.lang.payment_failed_try_again);
        }, 2000);
      }
    });
  }

  @HostListener('scroll') onScrollHost(e: Event): void {
    console.log(this.getYPosition(e));
  }
  // when scroll select currently selected category on menu
  public onScroll(ev) {
    const lol = document.querySelectorAll<HTMLElement>('.menu-list-container');

    let foundElement = false;
    let newThis = this;
    lol.forEach(function (eves): void {
      const value = eves.getBoundingClientRect().top;
      // console.log(value);
      if (value < 0 && value > -50) {
        newThis.scrolltoActive = parseInt(eves.id);
        console.log(eves.id);
        return;
      }
    });
  }

  getYPosition(e: Event): number {
    return (e.target as Element).scrollTop;
  }


  /* @HostListener('document:scroll', [])
   onWindowScroll() {
     console.log('hi');
     this.componentDiv.forEach(div => console.log(div));
     //const element = this.componentDiv.nativeElement;
     // const viewportOffset = element.getBoundingClientRect();
     // const top = viewportOffset.top;
     // if (top <= 0) {
     //   // Do something
     // }
   }*/



  async presentModal(type) {
    const modal = await this.modalController.create({
      component: ModalPopoverPage,
      cssClass: 'order-popup',
      componentProps: {
        'title': this.POPOVER_TYPES.ORDERING_TYPE.TITLE,
        'type': type,
        'origin': 'web-menu',
        'justSelectOrderType': true
      }
    });

    await modal.present();
    const { data } = await modal.onWillDismiss();
    return data;


  }

  async remove(index) {
    this.appService.appObject.orderObject.cart.splice(index, 1);
    this.appService.appObject.orderObjectDup.cart.splice(index, 1);
    this.appService.calculateCartAmounts();
    if (this.appService.appObject.orderObject.cart.length == 0) {
      this.dismiss();
    }
  }

  public dismiss() {
    this.appService.cartIsOpen = false;
    this.appService.hideCartButton = false;
    //this.appService.getRestaurantBySlug(this.appService.appObject.selectedRestaurant);
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    if (!this.appService.appObject.orderObject.cart_summery.min_reached && this.appService.appObject.orderObject.cart_summery.min_amount > 0) {
      this.appService.routeToSelectedRestaurant();
    }
    this.modalController.dismiss({
      'dismissed': true,
      'array': 'kk'
    });
  }

  /**
   * This will scroll to selected menu dish list
   * @param elementId menu category id
   */
  scrollToMenu(elementId) {
    this.scrolltoActive = elementId;
    let element = document.getElementById(elementId);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  }


  /**
   * Open checkout component, if user haven't logged in yet, then open login page
   */
  async openCheckout() {
    // new condition added to allow user to procedd to checkout even min order amount not been reached
    // let skipBelowMinOrderAmountCheck = false;
    // if((!this.appService.appObject.orderObject?.cart_summery?.min_reached && this.appService.appObject.postalCodeDetails && this.appService.appObject.settings.is_postalcode === 'true')){
    //   skipBelowMinOrderAmountCheck = true;
    // }
    
    // check if the minimum order amount is reached
    // !skipBelowMinOrderAmountCheck && 
    if (!this.appService.appObject.orderObject?.cart_summery?.min_reached && this.appService.appObject.orderObject.cart_summery.min_amount > 0)
      return;

    if(this.appService?.closenotice && !this.appService.isPreOrderAccept && !(this.appService.appObject?.selectedRestaurantDetails?.subscription_order_button == 'true' || this.appService.appObject?.selectedRestaurantDetails?.general_order_special_mode == 'true')){
      this.translate.get('key.we_are_closed_at_the_moment_and_wouldnt_accept_any_orders').toPromise().then((data) => {
        this.appService.showToast(data, 'danger', 'bottom', 5000);
      }).catch((err) => {
        console.log('error while fetching close notice : ', err);
      })
      return false;
    }  


    // check if the selected ordering method is currently available or will available within preorder days
    // if not, avoid opening the chekout process
    // This validation only trigger when only available method is "Genaral Ordering mode"
    if(this.appService.appObject.selectedRestaurantDetails.subscription_order_button !== 'true' && this.appService.appObject.selectedRestaurantDetails.general_order_button === 'true'){
      let availableMethods = this.appService.findSelectedRestaurantOrderTypesV2(this.appService.appObject.selectedRestaurantDetails, true);
      if(availableMethods){
        if(!availableMethods.deliveryMethods.includes(this.appService.appObject.selectedDeliveryMethod) && !availableMethods.futureAvailableMethods.includes(this.appService.appObject.selectedDeliveryMethod)){
          this.translate.get('key.selected_ordering_method_not_available_at_the_moment').toPromise().then((data) => {
            this.appService.showToast(data, 'danger', 'bottom', 5000);
          }).catch((err) => {
            console.log('translation issue for order method not available key');
          });
          return;
        }
      }
    }

    if(this.appService.appObject.selectedDeliveryMethod === 'delivery' && this.appService.appObject.selectedRestaurantDetails && this.appService.appObject.selectedRestaurantDetails.delivery_via_uber === 'true' && !this.appService.appObject.uberAddressDetailsObject){
      this.openLocationSelectPopup(false);
      return;
    }

    // calculate before checkout
    await this.appService.calculateCartAmounts();

    // if there is a coupon code, validate again before the checkout
    let couponFailed = false;
    this.couponError = '';
    if(this.appService.appObject.orderObject.cart_summery && this.appService.appObject.orderObject.cart_summery.coupon_details && this.appService.appObject.orderObject.cart_summery.coupon_details.coupon){
      this.couponValidatingNew = true;
      await this.appService.addCoupon(this.appService.appObject.orderObject.cart_summery.coupon_details.coupon).then((couponResponse) =>{
        if(!couponResponse.status){
          this.couponError = couponResponse.msg;
          couponFailed = true;
        }else{
          // all good
        }
      })
      this.couponValidatingNew = false;
    }
    if(couponFailed) return;


    // Check if there are not available dishes in the cart added previously
    let unavailableDishes = [];
    if (this.appService.appObject.orderObject.cart && this.appService.appObject.orderObject.cart.length) {
      unavailableDishes = this.appService.appObject.orderObject.cart.filter((dish) => dish.not_available);
      if (unavailableDishes.length) {
        this.translate.get('key.one_or_more_dishes_not_available_for').toPromise().then((translation) => {
          this.appService.showToast(translation + ' ' + this.appService.appObject.selectedDeliveryMethod, 'danger', '', 5000);
        });
        return;
      }
    }

    // check if the user did apply the coupon typed before checkout
    if (this.appService.appObject.couponWeb && !this.appService.appObject.couponWebAdded) {
      await this.translate.get('key.havent_applied_entered_coupon').toPromise().then((response) => {
        if (response) this.couponError = response;
        else this.couponError = 'key.havent_applied_entered_coupon';
      });
      return;
    } else if (this.couponValidating) {
      console.log('coupon validating in progress');
    }

    if (this.appService.appObject.settings.is_postalcode === 'true' && this.appService.appObject.selectedDeliveryMethod === 'delivery' && !this.appService.appObject.postalCodeDetails) {
      this.translate.get('key.please_select_your_delivery_area').toPromise().then((translation) => {
        this.appService.showToast(translation + '!', 'danger', '', 5000);
      });
      return;
    }

    setTimeout(() => { this.appService.appObject.isOrderProcess = true; this.appService.updateAppObject(); console.log('App : ', this.appService.appObject.isOrderProcess); }, 10);
    let modal = null;
    if (this.appService.appObject.isAuthed) {
      if (this.appService.appObject.selectedDeliveryMethod === 'delivery' && (!this.appService.appObject.myAddress.name || !this.appService.appObject.myAddress.lat || !this.appService.appObject.myAddress.lng) && this.appService.appObject.settings.is_postalcode !== 'true') {
        // locationToGo = this.POPOVER_TYPES.LOCATION_SELECT;
        // if user haven't select an address yet still has the order type as delivery, then let user to select address
        this.openLocationSelectPopup(false);
        return;
      } else {
        modal = await this.modalController.create({
          component: ModalPopoverPage,
          cssClass: 'checkout-popup',
          componentProps: {
            'title': this.POPOVER_TYPES.CHECKOUT.TITLE,
            'type': this.POPOVER_TYPES.CHECKOUT.TYPE,
          }
        });
      }
    } else {
      modal = await this.modalController.create({
        component: ModalPopoverPage,
        cssClass: 'login-popup',
        componentProps: {
          'title': this.POPOVER_TYPES.LOGIN.TITLE,
          'type': this.POPOVER_TYPES.LOGIN.TYPE,
          'isOrderProcessing': true
        }
      });
    }

    await modal.present();
  }

  /**
   * Open delivery address select popup
   */
  async openLocationSelectPopup(closeAfterSelecting) {
    let modal = await this.modalController.create({
      component: ModalPopoverPage,
      cssClass: 'checkout-popup',
      componentProps: {
        'title': this.POPOVER_TYPES.LOCATION_SELECT.TITLE,
        'type': this.POPOVER_TYPES.LOCATION_SELECT.TYPE,
        'justSelectDeliveryAddress': true,
      }
    });
    await modal.present();
  }

  /**
   * Open delivery address select popup
   */
  async openImagePreview(dishImageUrl, title) {
    if (dishImageUrl) {
      let modal = await this.modalController.create({
        component: ModalPopoverPage,
        cssClass: 'image-preview image-preview-no-header',
        componentProps: {
          'title': title,
          'type': this.POPOVER_TYPES.DISH_IMAGE_PREVIEW.TYPE,
          'dishImageURL': dishImageUrl
        }
      });
      await modal.present();
    }
  }

  /**
   * Add coupon
   */
  async addCoupon() {
    // if coupon contains an empty value no need to validate
    this.appService.appObject.couponWeb = this.appService.appObject.couponWeb.trim();
    if (!this.appService.appObject.couponWeb) return;

    this.couponError = '';
    this.couponValidating = true;

    if (!this.appService.appObject.user || this.appService.appObject.user.type !== 'registered') {
      // this.appService.showToast('In order to use coupons you must be logged in','danger','bottom',5000);
      this.translate.get('key.in_order_to_user_coupons').toPromise().then((response) => {
        this.couponError = response;
      });
      this.couponValidating = false;
      return;
    }

    await this.appService.addCoupon(this.appService.appObject.couponWeb).then(data => {
      this.couponError = '';
      if (data.status) {
        this.appService.appObject.couponWebAdded = true;
        //set coupon details
        this.appService.appObject.selectedCoupon = [];
        data.data['coupon_code'] = this.appService.appObject.couponWeb;
        this.appService.appObject.selectedCoupon.push(data.data);
        this.appService.calculateCartAmounts();
      } else {
        this.appService.appObject.couponWebAdded = false;
        this.appService.appObject.couponWeb = '';
        this.couponError = data && data.msg ? data.msg : '';

        this.appService.updateAppObject();
      }
      this.couponValidating = false;
    }, error => {
      this.appService.appObject.isLoading = false;
      this.couponValidating = false;
    });

  }

  /**
   * Remove added coupon
   */
  async removeCoupon() {
    this.couponError = '';
    this.appService.clearCouponDetails();
  }



  myalert(event, dish = null) {
    if (dish) dish.progressing = true;

    this.anicartstyle = 'left : ' + event.x + 'px; top: ' + event.y + 'px';
    let newThis = this;
    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    setTimeout(function () {
      newThis.animationcarticon = 'animation-cart-icon animation-cart-icon-animate';
      newThis.anicartstyle = 'left : 50% ; Top : 50%';
    }, 500);

    setTimeout(function () {
      newThis.animationcarticon = 'animation-cart-icon animation-cart-icon-animate animation-cart-icon-animate2';
    }, 1000);

    setTimeout(() => {
      const off = newThis.maincarticon.nativeElement.getBoundingClientRect();
      // console.log(off);
      newThis.anicartstyle = 'left : ' + (off.left + 100) + 'px; top: ' + (off.top + 40) + 'px';
      newThis.animationcarticon = 'animation-cart-icon animation-cart-icon-animate3';

    }, 2500);

    setTimeout(() => {

      newThis.anicartstyle = '';
      newThis.animationcarticon = 'animation-cart-icon';

      if (dish) {
        this.appService.addToCart(dish);
        dish.progressing = false;
      }

    }, 3000);

  };


  /**
   * Handle send to kitchen and pay button actions
   * @param action send_to_kitchen / pay
   * @returns 
   */
  async actionHandler(action: string) {
    if (this.appService.appObject.selectedDeliveryMethod === 'dine_in' && !this.appService.appObject.orderObject.selectedTable) {
      this.appService.appObject.isLoading = true;
      this.appService.fetchAllTablesOfRestaurant(this.appService.appObject.selectedRestaurantId).then(async (response: any) => {
        // console.log('table data : ' , response);
        let tables = response.data;
        let modal = await this.modalController.create({
          component: ModalPopoverPage,
          cssClass: '',
          componentProps: {
            'title': this.POPOVER_TYPES.TABLE_SELECT.TITLE,
            'type': this.POPOVER_TYPES.TABLE_SELECT.TYPE,
            'selectedRestaurantTableList': tables,
            'justToSelectATable': true
          }
        });
        modal.present();

        modal.onDidDismiss().then((data) => {
          if (data.data && data.data.status) {
            // console.log('you re good to go');
            this.actionHandler(action);
          }
        });
        this.appService.appObject.isLoading = false;
      }).catch((error) => {
        console.log('error while fetching tables : ', error);
        this.appService.appObject.isLoading = false;
      });
      return;
    }

    if (action === 'pay') {
      if (this.appService.hasNewDishesInCart()) {
        this.appService.appObject.isLoading = true;
        if (this.appService.appObject.orderObject.save_items && this.appService.appObject.orderObject.table_order_id) {
          await this.appService.updateKitchenOrder();
          // console.log('Kitchen Order Updated');
        } else {
          await this.appService.sendToKitchen(false);
          // console.log('Kitchen Order Created');
        }
        this.appService.appObject.isLoading = false;
      }
      this.openCheckout();
    } else if (action === 'send_to_kitchen') {
      if (this.appService.appObject.orderObject.save_items && this.appService.appObject.orderObject.table_order_id) {
        await this.appService.updateKitchenOrder();
      } else {
        await this.appService.sendToKitchen(false);
      }
    }
  }


  async incDish(dish) {
    dish.count++;
    this.appService.calculateCartAmounts();
  }


  async decDish(dish) {
    if (dish.count > 1) {
      dish.count--;
      this.appService.calculateCartAmounts();
    }
  }

  /**
   * 
   * get languages
   */
  async getLang() {
    await this.translate.get('key').subscribe(
      value => {
        this.lang = value;
      }
    )
  }

  /**
   * Opens delivery times and costs for selected postal code
   * @param event click event
   * @param openDetailComponent 
   */
  async openDeliveryTimeSlotDetails(event, openDetailComponent:boolean = false){
    // let lang = await this.storage.get('lang');
    // console.log('lang : ' , lang);
    
    const popover = await this.popoverCtrl.create({
      component: DeliveryTimesPage,
      cssClass: 'delivery-cost-tour-class',
      event: event,
      translucent: true,
      mode: 'ios',
      showBackdrop: true,
      backdropDismiss:true
    });
    await popover.present();
    // this.appService.tourModeOnDeliveryPriceWeb = true;

    // this.appService.appObject.tourEndDeliveryWeb = true;
    // this.appService.updateAppObject();
  }

  getDishById(id){
    for (let index = 0; index < this.appService.menuList.length; index++) {
      const dishes = this.appService.menuList[index].dishes;
      for (let ind = 0; ind < dishes.length; ind++) {
        const dish = dishes[ind];
        if(dish.id == id){
          return dish;
        }
        
      }
    }
    return null;
  }

  //edit cart item
  edit(dish, i){
    if(dish.size_info){
      let menuDish = this.getDishById(dish.dish_id);
      if(menuDish){
        //todo find dish
        this.appService.topingPopupEditOpen(menuDish, false ,i , dish);
      }
    }
  }

}

